import { CmpInitResponse, getCMPData, cmpCookie } from "@foundation/cmp-client";
import { timeoutSuccess } from "./timeouts";
import { ServerStorage, Storage } from "./Storage";
import fireEREvt from "./eventRecorderClient";

// this overrides default timeout of 10_000;
const local: ServerStorage = Storage.createLocalStorage();
const storageKey = "bbads_consent_data";

export const CONSENT_TIMEOUT = 500;
export const CONSENT_TIMEOUT_RESPONSE = "timeout";

async function getAndCacheConsent() {
    const consentData: CmpInitResponse = await getCMPData();

    local.setObj(storageKey, consentData);

    return consentData;
}

/**
 *
 * @param {Boolean} useCachedConsent
 * @returns {Promise<{ gdprApplies: Boolean, usPrivacyString: String, iabConsentString: String }>}
 */
export default async function getUserConsentData(isConsentTimeoutEnabled: boolean): Promise<CmpInitResponse> {
    fireEREvt("ad-cmp");

    const cachedConsentData = local.getObj(storageKey);
    const getAndCacheConsentPromise: Promise<CmpInitResponse> = (
        isConsentTimeoutEnabled
            ? Promise.race([getAndCacheConsent(), timeoutSuccess(CONSENT_TIMEOUT, {})]) : getAndCacheConsent()
    );

    if (cachedConsentData) {
        fireEREvt("ad-cachedcmp-resp", cachedConsentData);

        return cachedConsentData;
    }

    const cacheRes = await getAndCacheConsentPromise;

    fireEREvt("ad-cmp-resp", cacheRes);

    return cacheRes;
}

export function getConsentFlags() {
    return {
        reqAllowed: cmpCookie.reqAllowed(),
        funAllowed: cmpCookie.funAllowed(),
        padAllowed: cmpCookie.padAllowed()
    };
}
